import { schema } from 'normalizr';

const series = new schema.Entity('series', {}, { idAttribute: 'slug' });

const video = new schema.Entity('videos', {}, { idAttribute: 'slug' });

export const mediaItem = new schema.Entity(
  'media',
  { series, videos: [video] },
  {
    idAttribute: 'slug',
    processStrategy: entity => {
      switch (entity.type) {
        case 'game':
          return {
            ...entity,
            isStarted: false,
          };
          break;
        case 'video':
          return {
            ...entity,
            tags: entity.series.tags,
            gradeRange: entity.series.gradeRange,
          };
          break;
        default:
          return { ...entity };
      }
    },
  }
);
// mediaItem.define({
//   series: series,
//   videos: [mediaItem]
// });
export const arrayOfMedia = new schema.Array(mediaItem);

export const mediaList = new schema.Entity(
  'lists',
  { items: [mediaItem] },
  {
    idAttribute: 'listId',
  }
);

export const hero = new schema.Entity(
  'heroes',
  { items: [mediaItem] },
  {
    idAttribute: 'internalID',
  }
);
export const arrayOfLists = {
  lists: [mediaList],
  heroes: [hero],
};
